import {
  faInstagram,
  faLinkedin,
  faTwitter
} from '@fortawesome/free-brands-svg-icons'
import { faGlobe, faHorse } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from 'next/image'
import Link from 'next/link'

interface IProps {
  name: string
  avatar: string
  avatarPosition?: string
  role: string
  upstream?: string
  twitter?: string
  linkedIn?: string
  instagram?: string
  website?: string
  zed?: string
}

function TeamMember({
  name,
  avatar,
  avatarPosition,
  role,
  twitter,
  linkedIn,
  instagram,
  website,
  upstream,
  zed
}: IProps) {
  const priorityNames = ['Alex Taub', 'Michael Schonfeld', 'Sarah Wood']
  return (
    <li key={name} className="group">
      <div className="space-y-4">
        <div className="w-52 h-72 md:w-72 md:h-96 relative rounded-lg overflow-hidden opacity-80 filter grayscale group-hover:opacity-100 group-hover:filter-none group-hover:shadow-lg transition">
          <Image
            priority={priorityNames.includes(name)}
            fill
            sizes="25vw"
            className="object-cover"
            style={{ objectPosition: avatarPosition || '50% 50%' }}
            src={avatar}
            alt={name}
          />
        </div>

        <div className="space-y-3">
          <div className="text-xl leading-5 space-y-1">
            <h3 className="text-text-primary font-bold">{name}</h3>
            <p className="text-gray-500 uppercase font-normal text-xs">
              {role}
            </p>
          </div>

          <ul className="flex space-x-3">
            {upstream && (
              <li>
                <Link
                  target="_blank"
                  className="text-gray-400 hover:text-gray-500"
                  href={`/profiles/${upstream}`}
                >
                  <span className="sr-only">Upstream</span>
                  <Image
                    src={'/static/robot-no-lights.svg'}
                    alt="Upstream Logo"
                    width={24}
                    height={22}
                  />
                </Link>
              </li>
            )}

            {twitter && (
              <li>
                <Link
                  target="_blank"
                  className="text-gray-400 hover:text-gray-500"
                  href={twitter}
                >
                  <span className="sr-only">Twitter</span>
                  <FontAwesomeIcon icon={faTwitter} size={'lg'} />
                </Link>
              </li>
            )}

            {linkedIn && (
              <li>
                <Link
                  target="_blank"
                  className="text-gray-400 hover:text-gray-500"
                  href={linkedIn}
                >
                  <span className="sr-only">LinkedIn</span>
                  <FontAwesomeIcon icon={faLinkedin} size={'lg'} />
                </Link>
              </li>
            )}

            {instagram && (
              <li>
                <Link
                  target="_blank"
                  className="text-gray-400 hover:text-gray-500"
                  href={instagram}
                >
                  <span className="sr-only">Instagram</span>
                  <FontAwesomeIcon icon={faInstagram} size={'lg'} />
                </Link>
              </li>
            )}

            {website && (
              <li>
                <Link
                  target="_blank"
                  className="text-gray-400 hover:text-gray-500"
                  href={website}
                >
                  <span className="sr-only">Website</span>
                  <FontAwesomeIcon icon={faGlobe} size={'lg'} />
                </Link>
              </li>
            )}

            {zed && (
              <li>
                <Link
                  target="_blank"
                  className="text-gray-400 hover:text-gray-500"
                  href={zed}
                >
                  <span className="sr-only">Zed</span>
                  <FontAwesomeIcon icon={faHorse} size={'lg'} />
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </li>
  )
}

export default TeamMember
